module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap sunhomedetail-wrap flex-column"
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "flex-item"
  }, [(_vm.ShareInfoContent.shareImages.length > 0) ? _c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    ref: "mySwiper1",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.ShareInfoContent.shareImages), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('v-image', {
      attrs: {
        "width": 720,
        "imagePath": item.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "evaluate-detail"
  }, [_c('div', {
    staticClass: "evaluate-item"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "head"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/head_default_3x.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.ShareInfoContent.shareBy))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_c('span', {
    staticClass: "floatL"
  }, [_vm._v(_vm._s(_vm.ShareInfoContent.shareTime))])]), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
    staticClass: "evaluate-content"
  }, [_vm._v(_vm._s(_vm.ShareInfoContent.shareContent))])])]), _vm._v(" "), (_vm.ShareInfoContent.shareGoods != null && _vm.ShareInfoContent.shareGoods.length > 0) ? _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("商品信息")]), _vm._v(" "), _vm._l((_vm.ShareInfoContent.shareGoods), function(item) {
    return _c('div', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.viewGoodsDetail(item)
        }
      }
    }, [_c('span', [_c('label', {
      staticClass: "goodsTitle ellipsis"
    }, [_vm._v(_vm._s(item.goodsName))]), _c('label', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(item.goodsPrice))]), _c('label', {
      staticClass: "scandetail"
    }, [_vm._v("查看详情")])])])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36583fa5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/sunhomedetail.vue
// module id = 391
// module chunks = 68